module.exports = __webpack_public_path__ + "img/Locate_mob.86219b40.png";